import React from 'react'

import LiveLoading from 'live/components/ui/Loading'

import { LoadingContainer } from './styled'

interface IAbsoluteLoadingProps {
    show: boolean
    size?: number | 'sm' | 'md' | 'lg'
}

export const AbsoluteLoading: React.FC<IAbsoluteLoadingProps> = ({ show, size }) => {
    if (!show) {
        return <></>
    }

    return (
        <LoadingContainer>
            <LiveLoading show={true} size={size} />
        </LoadingContainer>
    )
}
